var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M12 11q.825 0 1.413-.587T14 9q0-.825-.587-1.412T12 7q-.825 0-1.412.588T10 9q0 .825.588 1.413T12 11m-.5 8v-3.754q-1.379-.102-2.4-.999q-1.02-.897-1.277-2.259q-1.586-.186-2.705-1.3Q4 9.573 4 8v-.385q0-.666.475-1.14Q4.949 6 5.615 6h2.039v-.385q0-.666.474-1.14Q8.603 4 9.27 4h5.462q.666 0 1.14.475q.475.474.475 1.14V6h2.039q.666 0 1.14.475q.475.474.475 1.14V8q0 1.573-1.118 2.688q-1.119 1.114-2.705 1.3q-.258 1.362-1.278 2.26q-1.02.896-2.399.998V19h2.615q.213 0 .357.144t.143.357q0 .212-.143.356q-.144.143-.357.143h-6.23q-.213 0-.357-.144q-.143-.144-.143-.357q0-.212.143-.356q.144-.143.357-.143zm-3.846-8.085V7H5.615q-.269 0-.442.173T5 7.615V8q0 1.123.762 1.953q.761.83 1.892.962m4.35 3.354q1.38 0 2.342-.965q.962-.964.962-2.342V5.615q0-.269-.173-.442T14.692 5H9.308q-.27 0-.443.173t-.173.442v5.347q0 1.378.966 2.342q.966.965 2.347.965m4.341-3.354q1.13-.132 1.892-.962T19 8v-.385q0-.269-.173-.442T18.385 7h-2.039zM12 9.635"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.b4858a8df2e515e6bb415eac59c309e5.svg";
export { ForwardRef as ReactComponent };